import React, { useContext } from "react";
import { IconButton, Grid, Grid2, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import styles from "./ImageUploadBox.module.css";
import { ErrorManagementContext } from "../../../../utils/errorManagement/ErrorManagementProvider";

const ImageUploadBox = ({ image, setImage }: { image: string | null, setImage: React.Dispatch<React.SetStateAction<string | null>> }) => {
    const { cookClubLog } = useContext(ErrorManagementContext);

    const handlePhotoUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];

            const allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

            // Validate file type
            if (!allowedFormats.includes(file.type)) {
                cookClubLog("Unsupported image format. Please upload an image in one of the following formats: PNG, JPEG, GIF, or WEBP.", "", {}, { ui: { type: "warning" }, browserConsole: true });

                return;
            }

            const imageUrl = URL.createObjectURL(file);
            setImage(imageUrl);



        }
    };

    const handleRemoveImage = () => {
        setImage(null);
    };

    return (
        <Grid2 className={styles.upload_box_wrapper}>
            <Grid2 className={styles.upload_box_container}>
                {image ? (
                    <Grid2 className={styles.image_container}>
                        <img src={image} alt="note-image" className={styles.uploaded_image} />
                        <IconButton
                            className={styles.closeIcon}
                            onClick={handleRemoveImage}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid2>
                ) : (
                    <label htmlFor="image-upload" className={styles.upload_box}>
                        <input
                            id="image-upload"
                            type="file"
                            accept="image/*"
                            onChange={handlePhotoUpload}
                            className={styles.file_input}
                        />
                        <Typography variant="caption3LightOutfit" className={styles.upload_text}>Upload Image</Typography>
                    </label>
                )}
            </Grid2>
        </Grid2>
    );
};

export default ImageUploadBox;